// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_body__H7PWk {
  background-color: lightgray;
}
.header_searchbar__rIKSC {
  outline: none;
  border: none;
  border-radius: 25px;
  background: #efeeed;
  width: 100%;
  padding: 0.5rem;
  padding-left: 1rem;
  border: solid 1px #c4c4c4;
  width: 284px;
  position: relative;
}
@media screen and (max-width: 991px) {
  .header_searchbar__rIKSC {
    width: 200px;
    /* margin-left: 15px; */
    /* position: relative; */
  }
}
.header_searchIcon__m5DsQ {
  padding: 4px !important;
  color: #373334 !important;
  outline: none !important;
  height: 30px;
}
.header_searchIconNew__kosAk {
  padding: 2px !important;
  /* margin-left: 6px !important; */
  color: #373334 !important;
  outline: none !important;
}
.header_plusIcon__S879L {
  padding: 4px;
  outline: none !important;
}

.header_searchbardarkTheme__uJzqO {
  background-color: #585858;
  color: whitesmoke;
  box-shadow: 0px 0px 0px;
}
.header_searchicondarkTheme__lrvNL {
  filter: invert(100%);
}
.header_collapse__Soy0I {
  width: 100%;
  min-width: 300px;
  max-width: 300px;
}
.header_autocomplete__irV3d {
  border-radius: 25px !important;
  border: none !important;
  outline: none !important;
}

.header_navbartoggler__Cxlxk {
  background: none;
  border: none;
}
@media all and (max-width: 371px) {
  .header_navbartoggler__Cxlxk {
    margin-top: 20px;
  }
}

.header_navbarexpand__CO2Ko {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  background-color: #ffffff;
  /* border-bottom: solid 1px #dee0e1; */
  width: 100%;
  padding-bottom: 10px;
  height: 64px;
}

.header_navbarexpandSignIn__UuB\\+0 {
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  border-bottom: solid 1px #dee0e1;
}
.header_navbarexpandMapSignIn__AHddo {
  display: flex;
  justify-content: space-between;
  /* background-color: #ffffff; */
  border-bottom: solid 1px #dee0e1;
}

.header_search__zniRN {
  padding-right: 10%;
}
.header_searchformafterkeypress__\\+mD33 {
  display: none;
}
.header_searchbarmargin__1tQ5p {
  position: relative;
  width: 100%;
  min-width: 200px;
  max-width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
}
.header_searchicon__u1Frl {
  background: #efeeed;
  position: absolute;
  outline: none !important;
  border: none !important;
  /* z-index: 2; */
  left: 2px;
  /* top: 1px; */
  /* bottom: 1px; */
  /* left: 1px; */
  border-radius: 20px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 7px 10px 10px 10px; */
}
/* @media screen and (min-width: 768px) {
  .searchicon{
    margin-left: 20px;
  }
} */

.header_iconbuttons__6Q3C2 {
  /* background-color: #F3F2F0; */
  background-color: transparent;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #373334;
  height: 90%;
  width: 65px;
  margin: 3px;
  outline: none !important;
}
.header_whiteBgColor__RDPf0 {
  background-color: #ffffff;
}
.header_iconbuttons__6Q3C2 p {
  font-size: 11px;
  font-weight: 600;
  margin: 8px 0px 0px 0px;
}
@media all and (max-width: 768px) {
  .header_iconbuttons__6Q3C2 {
    margin: 0 6px;
  }
}

.header_icons__D\\+h-o {
  display: flex;
}
.header_iconbuttons__6Q3C2 > .header_settingsicon__PSRGC {
  margin-left: 6px;
}

.header_iconbuttonimagedarkMode__uPwty {
  filter: invert(100%);
}

.header_header__PrKXj {
  display: flex;
  justify-content: space-between;
  padding-top: 1%;
}
.header_header__PrKXj > img {
  margin-left: 3%;
}

.header_header__PrKXj > .header_icons__D\\+h-o {
  margin-right: 15px;
}

.header_Ellipse__E8tcd {
  position: absolute;
  padding-bottom: 13px;
  padding-left: 12px;
}
.header_moderatorEllipse__sFn4s {
  position: absolute;
  padding-bottom: 13px;
  padding-left: 18px;
}

.header_icons__D\\+h-o:hover > {
  border-color: #50b7f5;
  color: #50b7f5;
}

.header_iconadjust__189Zu {
  margin: 0px;
}

/* Styles for wrapping the search box */

.header_main__S6zN- {
  width: 50%;
  margin: 50px auto;
}

/* Bootstrap 4 text input with search icon */

.header_has-search__DfsX\\+ .header_form-control__YRp7R {
  padding-left: 2.375rem;
}

.header_has-search__DfsX\\+ .header_form-control-feedback__-johY {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}

.header_iconadjust__189Zu > .header_iconbuttonsactive__7y6VS {
  border-bottom: 3px solid #50b7f5 !important;
}

.header_iconadjust__189Zu > .header_iconbuttons__6Q3C2:focus {
  outline: none !important;
  box-shadow: none !important;
}

.header_iconbuttons__6Q3C2:focus,
.header_iconbuttons__6Q3C2:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.header_iconadjust__189Zu > .header_iconbuttons__6Q3C2:hover {
  color: black;
  text-decoration: none;
}

.header_searchdropdown__8Epnd {
  display: none;
  background-color: white;
  margin: 1px 6px 0 6px;
  box-shadow: 0px 3px 6px #00000026;
  border-radius: 26px;
  position: absolute;
  right: -100%;
  top: 42px;
  padding: 22px 30px;
  z-index: 1;
}

.header_searchdropdown__8Epnd > div {
  list-style: none;
  margin-bottom: 9px;
  font-size: 14px;
  line-height: normal;
}
.header_searchdropdown__8Epnd > div > button {
  padding: 5px 14px;
  cursor: pointer;
}
.header_searchdropdown__8Epnd > div > button:last-child {
  border-left: none;
}
.header_searchoptions__AytOH {
  display: block;
}

.header_searchdropdown__8Epnd > li > input[type="checkbox"] {
  height: 13px !important;
  width: 13px !important;
  visibility: visible !important;
}
.header_searchdropdown__8Epnd > table {
  width: 100%;
}
.header_searchdropdown__8Epnd > table td {
  width: 50%;
}
.header_searchdropdown__8Epnd > table td svg {
  position: relative;
  top: 5px;
  left: 10px;
}
.header_close__kTneZ {
  border: none;
  outline: none !important;
  background-color: lightgray;
  float: right;
}

.header_searchcontentheader__2BmTt {
  padding-left: 15px;
  min-width: 550px;
  min-height: 40px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  background-color: lightgray;
  position: sticky;
  top: 0;
  z-index: 2;
}
.header_searchinfo__3qKeC {
  /* list-style-type: none;  */
  display: flex;
  flex-flow: row nowrap;
}
.header_searchprofileimage__acQW1 {
  max-width: 50px;
  max-height: 50px;
}

.header_moderatorbadge__OQPUE {
  position: relative;
  top: 27px;
  right: 19px;
  color: blue;
  background-color: white;
  padding: 2px;
}
.header_dialogcontentdiv__s-jzc {
  padding: 0px !important;
}
.header_dialogcontentdiv__s-jzc:first-child {
  padding-top: 0px;
}
.header_searchdata__kyFmb {
  padding: 28px;
}
.header_searchinfofilterdata__4ALAi {
  display: flex;
  align-items: center;
}
.header_searchinfofilterdata__4ALAi > p {
  margin-bottom: 0px;
}
.header_searchinfo__3qKeC > p {
  margin-left: 8px;
  margin-bottom: 0px;
}

.header_following__i3I\\+P {
  margin-left: 8px;
  font-size: 14px;
}
.header_searchtagupdateasksay__lqULz {
  width: 62%;
}
.header_taglocation__KFwq4 {
  color: orange;
}
.header_nodata__F8Ogj {
  color: red;
  margin-bottom: 0px;
}

.header_searchicondisplay__ogu6H {
  display: none;
}

.header_filter__UtBH0 {
  position: absolute;
  right: 14px;
  cursor: pointer;
}

@media screen and (min-width: 992px) {
  .header_searchbarmargin__1tQ5p {
    min-width: 284px;
    max-width: 284px;
  }
}

.header_filterbefore__jx--r {
  display: none;
}
.header_filterafter__EvLFO {
  filter: invert(53%) sepia(69%) saturate(4361%) hue-rotate(163deg)
    brightness(98%) contrast(101%);
}
.header_searchform__bxb0o {
  background: white;
  /* padding: 10px 12px 52px 12px; */
  border-radius: 26px;
}
.header_noshowwhitespace__Yqw71 {
  background: none;
  padding: 0;
  border-radius: 0;
}
.header_noshosearchinfocontent__xOQo8 {
  display: none;
}
.header_searchinfocontent__1nj9s {
  /* margin: 18px 3px 0px 24px; */
  overflow: hidden;
  position: absolute;
  bottom: -35px;
  cursor: pointer;
}

.header_headerImg__ee0Wa {
  height: 24px;
  width: 24px;
}

.header_headerProfileImg__9EH37 {
  border: 2px solid #373334bb;
  /* box-sizing: border-box; */
  border-radius: 5px;
  height: 26px;
  width: 25px;
  /* margin-top: -2px; */
  margin-bottom: -3px;
  box-shadow: 0px 1px 2px #93806e;
}

.header_headerHomeImg__7ishM {
  box-sizing: border-box;
  height: 22px;
  width: 22px;
  margin-top: 2px;
}

.header_filtercheckboxes__KrEtZ {
  margin-top: 3px;
  height: 18px;
  width: 18px;
}
.header_allcommunitys__dzavb {
  outline: none !important;
  border-radius: 20px 0px 0px 20px;
  background-color: white;
  border: 1px solid #b3b1b0;
  color: #b3b1b0;
}
.header_thiscommunity__Ukxbw {
  outline: none !important;
  border-radius: 0px 20px 20px 0px;
  background-color: white;
  border: 1px solid #b3b1b0;
  color: #b3b1b0;
}
/* .filteroptions > tr > td {
  padding: 0px 6px;
} */
.header_filteroptions__lIhg6 {
  border-collapse: separate; /* allow spacing */
  border-spacing: 0 10px; /* SAME vertical gap between rows */
}
.header_filteroptions__lIhg6 td {
  padding: 0 6px; /* horizontal spacing */
  vertical-align: middle; /* align rows */
}
.header_filteroptions__lIhg6 td span {
  display: inline-flex;
  align-items: center;
  gap: 6px; /* SAME gap everywhere */
}
.header_filterimages__Yy102 {
  padding: 0px 5px;
  vertical-align: text-top;
}
.header_whitespace__quHrg {
  margin: auto;
}

.header_buttonselectionstyle__MpWot {
  color: #4795de;
  background-color: #eff5fb;
  border: 1px solid #4795de;
}
@media all and (min-width: 992px) {
  .header_subwhitespace__2EZYq {
    margin-left: 120px;
  }
}
@media all and (min-width: 1024px) {
  .header_whitespace__quHrg {
    position: relative;
  }
}
@media screen and (min-width: 320px) {
  .header_searchdropdown__8Epnd {
    right: 0;
    width: 290px !important;
    padding: 15px 3px;
    padding-left: 15px;
  }
}
@media screen and (min-width: 480px) {
  .header_searchdropdown__8Epnd {
    right: 9px;
    width: 320px;
  }
}
@media all and (min-width: 768px) and (max-width: 991px) {
  .header_collapse__Soy0I {
    width: 100%;
    min-width: 350px;
  }
}
@media all and (max-width: 767px) {
  .header_collapse__Soy0I {
    width: 100%;
    min-width: 300px;
    max-width: 702px;
  }
  .header_navbarnav__AGpoT {
    flex-direction: row;
    justify-content: space-around;
  }
}

@media screen and (min-width: 768px) {
  .header_searchdropdown__8Epnd {
    transform: translateX(100px);
  }
}

.header_navbarnav__AGpoT {
  align-items: flex-end;
  justify-content: center;
}

.header_navbarnav__AGpoT li {
  padding: 0;
}

.header_notificationWrapper__xkjEo {
  width: 40vw;
  height: 80vh;
  min-width: 24vw;
  overflow-y: scroll;
  padding: 15px;
}

@media all and (min-width: 992px) {
  .header_notificationWrapper__xkjEo {
    width: 25vw;
  }
}
@media all and (min-width: 768px) {
  .header_notificationWrapper__xkjEo {
    height: 87vh;
  }
}

.header_inputSearchContainer__nCCth {
  display: flex;
  gap: 5px;
  margin-top: 8px;
  width: 100%;
}

.header_searchInput__CEjHN {
  border-radius: 25px;
  border: 0.7px solid #e5e5e5;
  padding: 2px;
  color: #373334;
  font-size: 14px !important;
  height: 30px;
}
input:focus {
  font-size: 14px;
}
.header_inputSearchContent__BYp6r {
  margin-top: 3px;
  font-size: 13px;
  width: 100%;
  color: #373334;
  overflow: hidden;
}
.header_searchDivider__-93qa {
  color: #373334;
}

.header_iconContainer__Wv\\+q7 {
  position: relative;
  display: inline-block;
}

.header_notificationBadge__1-v-x {
  position: absolute;
  top: -3px; /* Moves the badge slightly higher */
  right: -3px; /* Moves the badge slightly to the right */
  background-color: red;
  color: white;
  font-size: 10px; /* Reduced font size */
  font-weight: bold;
  border-radius: 10px; /* Keeps it rounded */
  min-width: 16px; /* Minimum width */
  height: 16px; /* Smaller height */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px; /* Adds padding for spacing */
}

.header_moderatorCountBadge__3GZNh {
  position: absolute;
  top: -3px; /* Moves the badge slightly higher */
  right: -15px; /* Moves the badge slightly to the right */
  background-color: red;
  color: white;
  font-size: 10px; /* Reduced font size */
  font-weight: bold;
  border-radius: 10px; /* Keeps it rounded */
  min-width: 16px; /* Minimum width */
  height: 16px; /* Smaller height */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 5px; /* Adds padding for spacing */
}

/* If the count is 3 digits or more, adjust width */
.header_notificationBadge__1-v-x.header_longCount__GM61w {
  min-width: 24px; /* Expands only to the right */
  padding: 2px 6px; /* Slightly more padding */
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/header/header.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;;;;GAIG;;AAEH;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,WAAW;EACX,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,uCAAuC;;AAEvC;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,4CAA4C;;AAE5C;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE;kCACgC;AAClC;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;AACA;;GAEG;AACH;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,sBAAsB,EAAE,mCAAmC;AAC7D;AACA;EACE,cAAc,EAAE,uBAAuB;EACvC,sBAAsB,EAAE,eAAe;AACzC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ,EAAE,wBAAwB;AACpC;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,QAAQ;IACR,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,oCAAoC;EAC/C,WAAW,EAAE,0CAA0C;EACvD,qBAAqB;EACrB,YAAY;EACZ,eAAe,EAAE,sBAAsB;EACvC,iBAAiB;EACjB,mBAAmB,EAAE,qBAAqB;EAC1C,eAAe,EAAE,kBAAkB;EACnC,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,oCAAoC;EAC/C,YAAY,EAAE,0CAA0C;EACxD,qBAAqB;EACrB,YAAY;EACZ,eAAe,EAAE,sBAAsB;EACvC,iBAAiB;EACjB,mBAAmB,EAAE,qBAAqB;EAC1C,eAAe,EAAE,kBAAkB;EACnC,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA,mDAAmD;AACnD;EACE,eAAe,EAAE,8BAA8B;EAC/C,gBAAgB,EAAE,0BAA0B;AAC9C","sourcesContent":[".body {\r\n  background-color: lightgray;\r\n}\r\n.searchbar {\r\n  outline: none;\r\n  border: none;\r\n  border-radius: 25px;\r\n  background: #efeeed;\r\n  width: 100%;\r\n  padding: 0.5rem;\r\n  padding-left: 1rem;\r\n  border: solid 1px #c4c4c4;\r\n  width: 284px;\r\n  position: relative;\r\n}\r\n@media screen and (max-width: 991px) {\r\n  .searchbar {\r\n    width: 200px;\r\n    /* margin-left: 15px; */\r\n    /* position: relative; */\r\n  }\r\n}\r\n.searchIcon {\r\n  padding: 4px !important;\r\n  color: #373334 !important;\r\n  outline: none !important;\r\n  height: 30px;\r\n}\r\n.searchIconNew {\r\n  padding: 2px !important;\r\n  /* margin-left: 6px !important; */\r\n  color: #373334 !important;\r\n  outline: none !important;\r\n}\r\n.plusIcon {\r\n  padding: 4px;\r\n  outline: none !important;\r\n}\r\n\r\n.searchbardarkTheme {\r\n  background-color: #585858;\r\n  color: whitesmoke;\r\n  box-shadow: 0px 0px 0px;\r\n}\r\n.searchicondarkTheme {\r\n  filter: invert(100%);\r\n}\r\n.collapse {\r\n  width: 100%;\r\n  min-width: 300px;\r\n  max-width: 300px;\r\n}\r\n.autocomplete {\r\n  border-radius: 25px !important;\r\n  border: none !important;\r\n  outline: none !important;\r\n}\r\n\r\n.navbartoggler {\r\n  background: none;\r\n  border: none;\r\n}\r\n@media all and (max-width: 371px) {\r\n  .navbartoggler {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n.navbarexpand {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1000;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n  background-color: #ffffff;\r\n  /* border-bottom: solid 1px #dee0e1; */\r\n  width: 100%;\r\n  padding-bottom: 10px;\r\n  height: 64px;\r\n}\r\n\r\n.navbarexpandSignIn {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  background-color: #ffffff;\r\n  border-bottom: solid 1px #dee0e1;\r\n}\r\n.navbarexpandMapSignIn {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  /* background-color: #ffffff; */\r\n  border-bottom: solid 1px #dee0e1;\r\n}\r\n\r\n.search {\r\n  padding-right: 10%;\r\n}\r\n.searchformafterkeypress {\r\n  display: none;\r\n}\r\n.searchbarmargin {\r\n  position: relative;\r\n  width: 100%;\r\n  min-width: 200px;\r\n  max-width: 200px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.searchicon {\r\n  background: #efeeed;\r\n  position: absolute;\r\n  outline: none !important;\r\n  border: none !important;\r\n  /* z-index: 2; */\r\n  left: 2px;\r\n  /* top: 1px; */\r\n  /* bottom: 1px; */\r\n  /* left: 1px; */\r\n  border-radius: 20px;\r\n  width: 38px;\r\n  height: 38px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* padding: 7px 10px 10px 10px; */\r\n}\r\n/* @media screen and (min-width: 768px) {\r\n  .searchicon{\r\n    margin-left: 20px;\r\n  }\r\n} */\r\n\r\n.iconbuttons {\r\n  /* background-color: #F3F2F0; */\r\n  background-color: transparent;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  color: #373334;\r\n  height: 90%;\r\n  width: 65px;\r\n  margin: 3px;\r\n  outline: none !important;\r\n}\r\n.whiteBgColor {\r\n  background-color: #ffffff;\r\n}\r\n.iconbuttons p {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  margin: 8px 0px 0px 0px;\r\n}\r\n@media all and (max-width: 768px) {\r\n  .iconbuttons {\r\n    margin: 0 6px;\r\n  }\r\n}\r\n\r\n.icons {\r\n  display: flex;\r\n}\r\n.iconbuttons > .settingsicon {\r\n  margin-left: 6px;\r\n}\r\n\r\n.iconbuttonimagedarkMode {\r\n  filter: invert(100%);\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding-top: 1%;\r\n}\r\n.header > img {\r\n  margin-left: 3%;\r\n}\r\n\r\n.header > .icons {\r\n  margin-right: 15px;\r\n}\r\n\r\n.Ellipse {\r\n  position: absolute;\r\n  padding-bottom: 13px;\r\n  padding-left: 12px;\r\n}\r\n.moderatorEllipse {\r\n  position: absolute;\r\n  padding-bottom: 13px;\r\n  padding-left: 18px;\r\n}\r\n\r\n.icons:hover > {\r\n  border-color: #50b7f5;\r\n  color: #50b7f5;\r\n}\r\n\r\n.iconadjust {\r\n  margin: 0px;\r\n}\r\n\r\n/* Styles for wrapping the search box */\r\n\r\n.main {\r\n  width: 50%;\r\n  margin: 50px auto;\r\n}\r\n\r\n/* Bootstrap 4 text input with search icon */\r\n\r\n.has-search .form-control {\r\n  padding-left: 2.375rem;\r\n}\r\n\r\n.has-search .form-control-feedback {\r\n  position: absolute;\r\n  z-index: 2;\r\n  display: block;\r\n  width: 2.375rem;\r\n  height: 2.375rem;\r\n  line-height: 2.375rem;\r\n  text-align: center;\r\n  pointer-events: none;\r\n  color: #aaa;\r\n}\r\n\r\n.iconadjust > .iconbuttonsactive {\r\n  border-bottom: 3px solid #50b7f5 !important;\r\n}\r\n\r\n.iconadjust > .iconbuttons:focus {\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.iconbuttons:focus,\r\n.iconbuttons:focus-visible {\r\n  outline: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.iconadjust > .iconbuttons:hover {\r\n  color: black;\r\n  text-decoration: none;\r\n}\r\n\r\n.searchdropdown {\r\n  display: none;\r\n  background-color: white;\r\n  margin: 1px 6px 0 6px;\r\n  box-shadow: 0px 3px 6px #00000026;\r\n  border-radius: 26px;\r\n  position: absolute;\r\n  right: -100%;\r\n  top: 42px;\r\n  padding: 22px 30px;\r\n  z-index: 1;\r\n}\r\n\r\n.searchdropdown > div {\r\n  list-style: none;\r\n  margin-bottom: 9px;\r\n  font-size: 14px;\r\n  line-height: normal;\r\n}\r\n.searchdropdown > div > button {\r\n  padding: 5px 14px;\r\n  cursor: pointer;\r\n}\r\n.searchdropdown > div > button:last-child {\r\n  border-left: none;\r\n}\r\n.searchoptions {\r\n  display: block;\r\n}\r\n\r\n.searchdropdown > li > input[type=\"checkbox\"] {\r\n  height: 13px !important;\r\n  width: 13px !important;\r\n  visibility: visible !important;\r\n}\r\n.searchdropdown > table {\r\n  width: 100%;\r\n}\r\n.searchdropdown > table td {\r\n  width: 50%;\r\n}\r\n.searchdropdown > table td svg {\r\n  position: relative;\r\n  top: 5px;\r\n  left: 10px;\r\n}\r\n.close {\r\n  border: none;\r\n  outline: none !important;\r\n  background-color: lightgray;\r\n  float: right;\r\n}\r\n\r\n.searchcontentheader {\r\n  padding-left: 15px;\r\n  min-width: 550px;\r\n  min-height: 40px;\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  background-color: lightgray;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n}\r\n.searchinfo {\r\n  /* list-style-type: none;  */\r\n  display: flex;\r\n  flex-flow: row nowrap;\r\n}\r\n.searchprofileimage {\r\n  max-width: 50px;\r\n  max-height: 50px;\r\n}\r\n\r\n.moderatorbadge {\r\n  position: relative;\r\n  top: 27px;\r\n  right: 19px;\r\n  color: blue;\r\n  background-color: white;\r\n  padding: 2px;\r\n}\r\n.dialogcontentdiv {\r\n  padding: 0px !important;\r\n}\r\n.dialogcontentdiv:first-child {\r\n  padding-top: 0px;\r\n}\r\n.searchdata {\r\n  padding: 28px;\r\n}\r\n.searchinfofilterdata {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.searchinfofilterdata > p {\r\n  margin-bottom: 0px;\r\n}\r\n.searchinfo > p {\r\n  margin-left: 8px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.following {\r\n  margin-left: 8px;\r\n  font-size: 14px;\r\n}\r\n.searchtagupdateasksay {\r\n  width: 62%;\r\n}\r\n.taglocation {\r\n  color: orange;\r\n}\r\n.nodata {\r\n  color: red;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.searchicondisplay {\r\n  display: none;\r\n}\r\n\r\n.filter {\r\n  position: absolute;\r\n  right: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .searchbarmargin {\r\n    min-width: 284px;\r\n    max-width: 284px;\r\n  }\r\n}\r\n\r\n.filterbefore {\r\n  display: none;\r\n}\r\n.filterafter {\r\n  filter: invert(53%) sepia(69%) saturate(4361%) hue-rotate(163deg)\r\n    brightness(98%) contrast(101%);\r\n}\r\n.searchform {\r\n  background: white;\r\n  /* padding: 10px 12px 52px 12px; */\r\n  border-radius: 26px;\r\n}\r\n.noshowwhitespace {\r\n  background: none;\r\n  padding: 0;\r\n  border-radius: 0;\r\n}\r\n.noshosearchinfocontent {\r\n  display: none;\r\n}\r\n.searchinfocontent {\r\n  /* margin: 18px 3px 0px 24px; */\r\n  overflow: hidden;\r\n  position: absolute;\r\n  bottom: -35px;\r\n  cursor: pointer;\r\n}\r\n\r\n.headerImg {\r\n  height: 24px;\r\n  width: 24px;\r\n}\r\n\r\n.headerProfileImg {\r\n  border: 2px solid #373334bb;\r\n  /* box-sizing: border-box; */\r\n  border-radius: 5px;\r\n  height: 26px;\r\n  width: 25px;\r\n  /* margin-top: -2px; */\r\n  margin-bottom: -3px;\r\n  box-shadow: 0px 1px 2px #93806e;\r\n}\r\n\r\n.headerHomeImg {\r\n  box-sizing: border-box;\r\n  height: 22px;\r\n  width: 22px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.filtercheckboxes {\r\n  margin-top: 3px;\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n.allcommunitys {\r\n  outline: none !important;\r\n  border-radius: 20px 0px 0px 20px;\r\n  background-color: white;\r\n  border: 1px solid #b3b1b0;\r\n  color: #b3b1b0;\r\n}\r\n.thiscommunity {\r\n  outline: none !important;\r\n  border-radius: 0px 20px 20px 0px;\r\n  background-color: white;\r\n  border: 1px solid #b3b1b0;\r\n  color: #b3b1b0;\r\n}\r\n/* .filteroptions > tr > td {\r\n  padding: 0px 6px;\r\n} */\r\n.filteroptions {\r\n  border-collapse: separate; /* allow spacing */\r\n  border-spacing: 0 10px; /* SAME vertical gap between rows */\r\n}\r\n.filteroptions td {\r\n  padding: 0 6px; /* horizontal spacing */\r\n  vertical-align: middle; /* align rows */\r\n}\r\n.filteroptions td span {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px; /* SAME gap everywhere */\r\n}\r\n.filterimages {\r\n  padding: 0px 5px;\r\n  vertical-align: text-top;\r\n}\r\n.whitespace {\r\n  margin: auto;\r\n}\r\n\r\n.buttonselectionstyle {\r\n  color: #4795de;\r\n  background-color: #eff5fb;\r\n  border: 1px solid #4795de;\r\n}\r\n@media all and (min-width: 992px) {\r\n  .subwhitespace {\r\n    margin-left: 120px;\r\n  }\r\n}\r\n@media all and (min-width: 1024px) {\r\n  .whitespace {\r\n    position: relative;\r\n  }\r\n}\r\n@media screen and (min-width: 320px) {\r\n  .searchdropdown {\r\n    right: 0;\r\n    width: 290px !important;\r\n    padding: 15px 3px;\r\n    padding-left: 15px;\r\n  }\r\n}\r\n@media screen and (min-width: 480px) {\r\n  .searchdropdown {\r\n    right: 9px;\r\n    width: 320px;\r\n  }\r\n}\r\n@media all and (min-width: 768px) and (max-width: 991px) {\r\n  .collapse {\r\n    width: 100%;\r\n    min-width: 350px;\r\n  }\r\n}\r\n@media all and (max-width: 767px) {\r\n  .collapse {\r\n    width: 100%;\r\n    min-width: 300px;\r\n    max-width: 702px;\r\n  }\r\n  .navbarnav {\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .searchdropdown {\r\n    transform: translateX(100px);\r\n  }\r\n}\r\n\r\n.navbarnav {\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n}\r\n\r\n.navbarnav li {\r\n  padding: 0;\r\n}\r\n\r\n.notificationWrapper {\r\n  width: 40vw;\r\n  height: 80vh;\r\n  min-width: 24vw;\r\n  overflow-y: scroll;\r\n  padding: 15px;\r\n}\r\n\r\n@media all and (min-width: 992px) {\r\n  .notificationWrapper {\r\n    width: 25vw;\r\n  }\r\n}\r\n@media all and (min-width: 768px) {\r\n  .notificationWrapper {\r\n    height: 87vh;\r\n  }\r\n}\r\n\r\n.inputSearchContainer {\r\n  display: flex;\r\n  gap: 5px;\r\n  margin-top: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.searchInput {\r\n  border-radius: 25px;\r\n  border: 0.7px solid #e5e5e5;\r\n  padding: 2px;\r\n  color: #373334;\r\n  font-size: 14px !important;\r\n  height: 30px;\r\n}\r\ninput:focus {\r\n  font-size: 14px;\r\n}\r\n.inputSearchContent {\r\n  margin-top: 3px;\r\n  font-size: 13px;\r\n  width: 100%;\r\n  color: #373334;\r\n  overflow: hidden;\r\n}\r\n.searchDivider {\r\n  color: #373334;\r\n}\r\n\r\n.iconContainer {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.notificationBadge {\r\n  position: absolute;\r\n  top: -3px; /* Moves the badge slightly higher */\r\n  right: -3px; /* Moves the badge slightly to the right */\r\n  background-color: red;\r\n  color: white;\r\n  font-size: 10px; /* Reduced font size */\r\n  font-weight: bold;\r\n  border-radius: 10px; /* Keeps it rounded */\r\n  min-width: 16px; /* Minimum width */\r\n  height: 16px; /* Smaller height */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2px 5px; /* Adds padding for spacing */\r\n}\r\n\r\n.moderatorCountBadge {\r\n  position: absolute;\r\n  top: -3px; /* Moves the badge slightly higher */\r\n  right: -15px; /* Moves the badge slightly to the right */\r\n  background-color: red;\r\n  color: white;\r\n  font-size: 10px; /* Reduced font size */\r\n  font-weight: bold;\r\n  border-radius: 10px; /* Keeps it rounded */\r\n  min-width: 16px; /* Minimum width */\r\n  height: 16px; /* Smaller height */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2px 5px; /* Adds padding for spacing */\r\n}\r\n\r\n/* If the count is 3 digits or more, adjust width */\r\n.notificationBadge.longCount {\r\n  min-width: 24px; /* Expands only to the right */\r\n  padding: 2px 6px; /* Slightly more padding */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `header_body__H7PWk`,
	"searchbar": `header_searchbar__rIKSC`,
	"searchIcon": `header_searchIcon__m5DsQ`,
	"searchIconNew": `header_searchIconNew__kosAk`,
	"plusIcon": `header_plusIcon__S879L`,
	"searchbardarkTheme": `header_searchbardarkTheme__uJzqO`,
	"searchicondarkTheme": `header_searchicondarkTheme__lrvNL`,
	"collapse": `header_collapse__Soy0I`,
	"autocomplete": `header_autocomplete__irV3d`,
	"navbartoggler": `header_navbartoggler__Cxlxk`,
	"navbarexpand": `header_navbarexpand__CO2Ko`,
	"navbarexpandSignIn": `header_navbarexpandSignIn__UuB+0`,
	"navbarexpandMapSignIn": `header_navbarexpandMapSignIn__AHddo`,
	"search": `header_search__zniRN`,
	"searchformafterkeypress": `header_searchformafterkeypress__+mD33`,
	"searchbarmargin": `header_searchbarmargin__1tQ5p`,
	"searchicon": `header_searchicon__u1Frl`,
	"iconbuttons": `header_iconbuttons__6Q3C2`,
	"whiteBgColor": `header_whiteBgColor__RDPf0`,
	"icons": `header_icons__D+h-o`,
	"settingsicon": `header_settingsicon__PSRGC`,
	"iconbuttonimagedarkMode": `header_iconbuttonimagedarkMode__uPwty`,
	"header": `header_header__PrKXj`,
	"Ellipse": `header_Ellipse__E8tcd`,
	"moderatorEllipse": `header_moderatorEllipse__sFn4s`,
	"iconadjust": `header_iconadjust__189Zu`,
	"main": `header_main__S6zN-`,
	"has-search": `header_has-search__DfsX+`,
	"form-control": `header_form-control__YRp7R`,
	"form-control-feedback": `header_form-control-feedback__-johY`,
	"iconbuttonsactive": `header_iconbuttonsactive__7y6VS`,
	"searchdropdown": `header_searchdropdown__8Epnd`,
	"searchoptions": `header_searchoptions__AytOH`,
	"close": `header_close__kTneZ`,
	"searchcontentheader": `header_searchcontentheader__2BmTt`,
	"searchinfo": `header_searchinfo__3qKeC`,
	"searchprofileimage": `header_searchprofileimage__acQW1`,
	"moderatorbadge": `header_moderatorbadge__OQPUE`,
	"dialogcontentdiv": `header_dialogcontentdiv__s-jzc`,
	"searchdata": `header_searchdata__kyFmb`,
	"searchinfofilterdata": `header_searchinfofilterdata__4ALAi`,
	"following": `header_following__i3I+P`,
	"searchtagupdateasksay": `header_searchtagupdateasksay__lqULz`,
	"taglocation": `header_taglocation__KFwq4`,
	"nodata": `header_nodata__F8Ogj`,
	"searchicondisplay": `header_searchicondisplay__ogu6H`,
	"filter": `header_filter__UtBH0`,
	"filterbefore": `header_filterbefore__jx--r`,
	"filterafter": `header_filterafter__EvLFO`,
	"searchform": `header_searchform__bxb0o`,
	"noshowwhitespace": `header_noshowwhitespace__Yqw71`,
	"noshosearchinfocontent": `header_noshosearchinfocontent__xOQo8`,
	"searchinfocontent": `header_searchinfocontent__1nj9s`,
	"headerImg": `header_headerImg__ee0Wa`,
	"headerProfileImg": `header_headerProfileImg__9EH37`,
	"headerHomeImg": `header_headerHomeImg__7ishM`,
	"filtercheckboxes": `header_filtercheckboxes__KrEtZ`,
	"allcommunitys": `header_allcommunitys__dzavb`,
	"thiscommunity": `header_thiscommunity__Ukxbw`,
	"filteroptions": `header_filteroptions__lIhg6`,
	"filterimages": `header_filterimages__Yy102`,
	"whitespace": `header_whitespace__quHrg`,
	"buttonselectionstyle": `header_buttonselectionstyle__MpWot`,
	"subwhitespace": `header_subwhitespace__2EZYq`,
	"navbarnav": `header_navbarnav__AGpoT`,
	"notificationWrapper": `header_notificationWrapper__xkjEo`,
	"inputSearchContainer": `header_inputSearchContainer__nCCth`,
	"searchInput": `header_searchInput__CEjHN`,
	"inputSearchContent": `header_inputSearchContent__BYp6r`,
	"searchDivider": `header_searchDivider__-93qa`,
	"iconContainer": `header_iconContainer__Wv+q7`,
	"notificationBadge": `header_notificationBadge__1-v-x`,
	"moderatorCountBadge": `header_moderatorCountBadge__3GZNh`,
	"longCount": `header_longCount__GM61w`
};
export default ___CSS_LOADER_EXPORT___;
